var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-lg-3"},[_c('b',[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"col-1 d-none d-lg-flex justify-content-end"},[_vm._v(":")]),_c('div',{staticClass:"col-lg-4"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }